if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartPageItems = document.querySelector('cart-items');
        this.cart = this.cartPageItems || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (!this.cartPageItems && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        document.addEventListener('recheck:quota', updateAllQuotaButtons);
        updateAllQuotaButtons();

        // document.addEventListener('quantity:changed', () => {
        //   fetch('/cart.js')
        //     .then(res => res.json())
        //     .then(cart => updateAllQuotaButtons(cart))
        //     .catch(console.error);
        // });
      }

      disconnectedCallback() {
        document.removeEventListener('recheck:quota', updateAllQuotaButtons);
        updateAllQuotaButtons();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (
          this.submitButton.getAttribute('aria-disabled') === 'true' ||
          this.submitButton.hasAttribute('disabled') ||
          this.submitButton.classList.contains('disabled')
        ) return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          const sections = this.cartPageItems ? this.cartPageItems.getSectionsToRender().map(s => s.section) : this.cart.getSectionsToRender().map(s => s.id);

          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement?.(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description || response.message || 'Unable to add to cart');
              document.dispatchEvent(new CustomEvent('recheck:quota'));

              const finishHandler = () => {
                document.removeEventListener('quota:finished', finishHandler);
              };
              document.addEventListener('quota:finished', finishHandler);
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            const afterRender = () => {
              if (this.cartPageItems) {
                this.renderCartPageSections(response); // new
                this.cleanupLoading();
                fetch('/cart.js')
                  .then(res => res.json())
                  .then(cart => updateAllQuotaButtons(cart))
                  .catch(console.error);
                return;
              } else {
                this.cart.renderContents(response);
                this.cleanupLoading();
                fetch('/cart.js')
                  .then(res => res.json())
                  .then(cart => updateAllQuotaButtons(cart))
                  .catch(console.error);
                return;
              }
            };
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => setTimeout(afterRender), { once: true });
              quickAddModal.hide(true);
            } else {
              afterRender();
            }

          })
          .catch((e) => {
            console.error(e);
            this.cleanupLoading();
            updateAllQuotaButtons();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        if (!this.errorMessageWrapper) {
          this.errorMessageWrapper = document.querySelector('.warning-message');
        }

        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('p');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessageWrapper.classList.add('active');

          setTimeout(() => {
            this.cleanupLoading();
            this.errorMessageWrapper.classList.remove('active');
          }, 5000);
        }
      }

      cleanupLoading() {
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading__spinner').classList.add('hidden');

        if (this.submitButton.hasAttribute('disabled') || 
            this.submitButton.classList.contains('disabled')) {
          return;
        }

        this.submitButton.removeAttribute('aria-disabled');
        const span = this.submitButton.querySelector('span');
        if (span) {
          span.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      toggleSubmitButton(disable, message) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (message) {
            this.submitButtonText.textContent = message;
          } else {
            this.submitButtonText.textContent = window.variantStrings.soldOut || 'Sold out';
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.classList.remove('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart || 'Add to cart';
        }
      }

      renderCartPageSections(parsedState) {
        // `parsedState.sections` is an object keyed by section handle/id requested in `sections` param
        // We will replace innerHTML using the same rules as CartItems.updateQuantity().
        // See cart.js getSectionsToRender(). :contentReference[oaicite:1]{index=1}

        const cartItemsEl = document.querySelector('cart-items');
        if (!cartItemsEl) return;

        const cartFullWrapper = document.getElementById('cart-full-wrapper');
        if (cartFullWrapper) cartFullWrapper.classList.remove('is-empty');

        const sectionsToRender = cartItemsEl.getSectionsToRender();

        sectionsToRender.forEach((section) => {
          const container = document.getElementById(section.id);
          if (!container) return;

          // Section selector can be a string or an array (footer case)
          if (Array.isArray(section.selector)) {
            section.selector.forEach((sel) => {
              const targets = container.querySelectorAll(sel);
              targets.forEach((target) => {
                target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], sel);
              });
            });
          } else {
            const target =
              container.querySelector(section.selector) || container;
            target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        });
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }
    }
  );
}

/* === GLOBAL QUOTA HANDLER === */
function updateAllQuotaButtons(cart = null) {
  const quotaDataEls = document.querySelectorAll('.quota-data');

  const cartTotal = cart?.total_price ? cart.total_price / 100 : 0;
  const cartItems = Array.isArray(cart?.items) ? cart.items : [];

  quotaDataEls.forEach((el) => {
    const quota = JSON.parse(el.textContent);
    const sku = quota.product_sku;
    if (!sku) return;

    const button = document.querySelector(`button[type="submit"][data-product-sku="${CSS.escape(sku)}"]`);
    if (!button) return;
    const span = button.querySelector('span');

    let exceeded = false;
    let soldOut = false;
    let message = 'Add to cart';

    // --- Case: Sold Out ---
    // Prefer backend quota flag if available
    if (quota.available === false) {
      soldOut = true;
      message = window.variantStrings?.soldOut || 'Sold out';
    }
    // Fallback: check data attribute from HTML (if theme sets it)
    if (!soldOut && button.dataset.variantAvailable === 'false') {
      soldOut = true;
      message = window.variantStrings?.soldOut || 'Sold out';
    }

    // --- SKU / Group Quota ---
    if (!soldOut && quota.exceed) {
      exceeded = true;
      // message = window.variantStrings?.limitReached || 'Limit Reached';
    }

    // --- Quantity Limits (monthly, quarterly, yearly) ---
    if (!soldOut && !exceeded) {
      let currentQty = quota.order_quantity || 0;
      if (cart && Array.isArray(cart.items)) {
        const sameSkuItems = cart.items.filter(i => i.sku === sku);
        const cartQty = sameSkuItems.reduce((sum, i) => sum + i.quantity, 0);
        currentQty += cartQty;
      }
      if (quota.monthly_limit > 0 && currentQty >= quota.monthly_limit) {
        exceeded = true;
        // message = window.variantStrings?.limitReached || 'Limit Reached';
      }
      if (quota.quarterly_limit > 0 && currentQty >= quota.quarterly_limit) {
        exceeded = true;
        // message = window.variantStrings?.limitReached || 'Limit Reached';
      }
      if (quota.yearly_limit > 0 && currentQty >= quota.yearly_limit) {
        exceeded = true;
        // message = window.variantStrings?.limitReached || 'Limit Reached';
      }
    }

    // --- Purchase Limit (amount based) ---
    if (!soldOut && !exceeded) {
      const productPrice = quota.product_price || 0;

      const totalMonthly   = quota.order_total_history_monthly   + cartTotal;
      const totalQuarterly = quota.order_total_history_quarterly + cartTotal;
      const totalYearly    = quota.order_total_history_yearly    + cartTotal;

      const remainingMonthly   = quota.monthly_purchase   ? quota.monthly_purchase   - totalMonthly   : Infinity;
      const remainingQuarterly = quota.quarterly_purchase ? quota.quarterly_purchase - totalQuarterly : Infinity;
      const remainingYearly    = quota.yearly_purchase    ? quota.yearly_purchase    - totalYearly    : Infinity;

      if (
        (quota.monthly_purchase   > 0 && productPrice > remainingMonthly) ||
        (quota.quarterly_purchase > 0 && productPrice > remainingQuarterly) ||
        (quota.yearly_purchase    > 0 && productPrice > remainingYearly)
      ) {
        exceeded = true;
        // message = window.variantStrings?.limitReached || 'Limit Reached';
      }
    }

    // --- Apply state ---
    if (soldOut || exceeded) {
      // button.setAttribute('disabled', 'true');
      // button.setAttribute('aria-disabled', 'true');
      // button.classList.add('disabled');
      // if (span) span.textContent = message;
    } else {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.classList.remove('disabled');
      if (span) span.textContent = window.variantStrings?.addToCart || 'Add to cart';
    }
  });

  document.dispatchEvent(new CustomEvent('quota:finished'));
}

document.addEventListener('recheck:quota', () => {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => updateAllQuotaButtons(cart));
});

function checkPurchaseLimits(cart, quotaDataList) {
  quotaDataList.forEach(d => {
    const sku = d.product_sku;
    if (!sku) return;

    let exceeded = false;

    // Remaining budgets
    const remainingMonthly   = d.monthly_purchase   ? (d.monthly_purchase - d.order_total_price)   : Infinity;
    const remainingQuarterly = d.quarterly_purchase ? (d.quarterly_purchase - d.order_total_price) : Infinity;
    const remainingYearly    = d.yearly_purchase    ? (d.yearly_purchase - d.order_total_price)    : Infinity;

    // Find product price from cart.items or from DOM
    let productPrice = 0;
    const cartItem = cart.items.find(i => i.sku === sku);
    if (cartItem) {
      productPrice = cartItem.price / 100; // Shopify cart.js returns price in cents
    } else {
      const el = document.querySelector(`[data-product-sku="${CSS.escape(sku)}"]`);
      if (el && el.dataset.productPrice) {
        productPrice = Number(el.dataset.productPrice);
      }
    }

    // Check if product price exceeds any remaining limit
    if (d.monthly_purchase > 0 && productPrice > remainingMonthly) exceeded = true;
    if (d.quarterly_purchase > 0 && productPrice > remainingQuarterly) exceeded = true;
    if (d.yearly_purchase > 0 && productPrice > remainingYearly) exceeded = true;

    if (exceeded) {
      setSkuButtonState(sku, true, 'Limit Reached');
    }
  });
}


function setSkuButtonState(sku, disable, message) {
  const els = document.querySelectorAll(`button[type="submit"][data-product-sku="${CSS.escape(sku)}"]`);
  els.forEach(el => {
    const btn = el.tagName === 'BUTTON' ? el : el.querySelector('button');
    if (!btn) return;
    const span = btn.querySelector('span');
    if (disable) {
      // btn.setAttribute('disabled', 'true');
      // btn.setAttribute('aria-disabled', 'true');
      // btn.classList.add('disabled');
      // if (span) span.textContent = message || 'Limit Reached';
    } else {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('disabled');
      if (span) span.textContent = window.variantStrings?.addToCart || 'Add to cart';
    }
  });
}

// document.addEventListener('DOMContentLoaded', updateAllQuotaButtons);
